import {
  CREATE_POLICY,
  EDIT_POLICY,
  GET_POLICIES,
  GET_POLICY_DETAIL,
  requestType,
  failedType,
  succeedType,
} from "./../actions/actionTypes";

const initState = {
  policies: [],
  policy: {},
  is_fetching: false,
  getting_policy_detail: false,
  editting_policy: false,
};

export const policiesReducer = (state = initState, action) => {
  switch (action.type) {
    case requestType(CREATE_POLICY):
    case requestType(GET_POLICIES):
      return {
        ...state,
        is_fetching: true,
      };
    case succeedType(CREATE_POLICY):
      return {
        ...state,
        is_fetching: false,
      };
    case succeedType(GET_POLICIES):
      return {
        ...state,
        policies: action.policies,
        is_fetching: false,
      };
    case failedType(CREATE_POLICY):
    case failedType(GET_POLICIES):
      return {
        ...state,
        is_fetching: false,
      };
    case requestType(GET_POLICY_DETAIL):
      return {
        ...state,
        getting_policy_detail: true,
      };
    case succeedType(GET_POLICY_DETAIL):
      return {
        ...state,
        getting_policy_detail: false,
        policy: action.policy,
      };
    case failedType(GET_POLICY_DETAIL):
      return {
        ...state,
        getting_policy_detail: false,
      };
    case requestType(EDIT_POLICY):
      return {
        ...state,
        editting_policy: true,
      };
    case succeedType(EDIT_POLICY):
      return {
        ...state,
        editting_policy: false,
      };
    case failedType(EDIT_POLICY):
      return {
        ...state,
        editting_policy: false,
      };
    default:
      return state;
  }
};
